import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "user-form email-setts"
}
const _hoisted_3 = { class: "user-form profile-form" }
const _hoisted_4 = { class: "row h2" }
const _hoisted_5 = { class: "col-md-6 col-sm-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bag-check-fill" }, null, -1)
const _hoisted_7 = { class: "d-flex justify-content-end align-items-center col-md-6 col-sm-12" }
const _hoisted_8 = { class: "me-2" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "small-fs-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-caret-left-fill" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clearboth" }, null, -1)
const _hoisted_17 = { class: "setting-data" }
const _hoisted_18 = { class: "row align-items-center" }
const _hoisted_19 = { class: "col-md-6 col-sm-12 mb-0" }
const _hoisted_20 = { class: "col-md-6 col-sm-12 d-flex justify-content-end" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "table" }
const _hoisted_24 = {
  "show-sm": "",
  "show-xs": "",
  "hide-md": "",
  "hide-lg": "",
  class: "d-block d-md-none"
}
const _hoisted_25 = { class: "d-block my-3" }
const _hoisted_26 = { class: "d-none d-md-block" }
const _hoisted_27 = { class: "d-none t-d-md-table-cell" }
const _hoisted_28 = { class: "d-none t-d-md-table-cell" }
const _hoisted_29 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_30 = { class: "d-none t-d-md-table-cell" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { colspan: "5" }
const _hoisted_33 = { class: "text-center py-2" }
const _hoisted_34 = { class: "d-none d-md-block" }
const _hoisted_35 = ["onClick", "title"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-grid-3x3-gap-fill" }, null, -1)
const _hoisted_37 = {
  class: "d-block d-md-none",
  style: {"position":"relative"}
}
const _hoisted_38 = { style: {"padding":"5px 0"} }
const _hoisted_39 = { class: "bold" }
const _hoisted_40 = ["onClick", "title"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-grid-3x3-gap-fill" }, null, -1)
const _hoisted_42 = { style: {"padding":"5px 0"} }
const _hoisted_43 = { class: "bold" }
const _hoisted_44 = { style: {"padding":"5px 0"} }
const _hoisted_45 = { class: "bold" }
const _hoisted_46 = { style: {"padding":"5px 0"} }
const _hoisted_47 = { class: "bold" }
const _hoisted_48 = { style: {"padding":"5px 0"} }
const _hoisted_49 = { class: "bold" }
const _hoisted_50 = { class: "d-none t-d-md-table-cell" }
const _hoisted_51 = { class: "d-none t-d-md-table-cell" }
const _hoisted_52 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_53 = { class: "d-none t-d-md-table-cell" }
const _hoisted_54 = { class: "col-md-6 col-sm-12" }
const _hoisted_55 = { class: "area-info" }
const _hoisted_56 = { class: "col-md-6 col-sm-12" }
const _hoisted_57 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_jw_pager = _resolveComponent("jw-pager")!
  const _component_printer_dialog = _resolveComponent("printer-dialog")!
  const _component_DeliveryOperModal = _resolveComponent("DeliveryOperModal")!
  const _component_DeliverOperDetailsModal = _resolveComponent("DeliverOperDetailsModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isStillLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa', 'fa-spinner'],
            class: "fs-1"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode("  " + _toDisplayString(_ctx.language.delivs_by_order), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control input-sm",
                    placeholder: _ctx.language.search.toLowerCase(),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemSearchKey) = $event))
                  }, null, 8, _hoisted_9), [
                    [_vModelText, _ctx.itemSearchKey]
                  ])
                ])
              ])
            ]),
            _createElementVNode("p", _hoisted_10, [
              _createElementVNode("span", null, [
                _createVNode(_component_RouterLink, { to: "/app/sales/deliveries/list" }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _createTextVNode("  " + _toDisplayString(_ctx.language.order_nbr) + ": ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.orderDelivStatus.orderNbr), 1),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.customer) + ": ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.orderDelivStatus.customerName), 1),
                    _hoisted_12,
                    _createTextVNode("       " + _toDisplayString(_ctx.language.ordered_qty) + ": ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.orderDelivStatus.orderQty)), 1),
                    _hoisted_13,
                    _createTextVNode("       " + _toDisplayString(_ctx.language.deliv_qty) + ": ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.orderDelivStatus.delivQty)), 1),
                    _hoisted_14,
                    _createTextVNode("       " + _toDisplayString(_ctx.language.rem_qty) + ": ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.orderDelivStatus.remQty)), 1),
                    _hoisted_15
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.language.delivs_by_order_msg), 1),
            _hoisted_16
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("h3", _hoisted_19, _toDisplayString(_ctx.language.delivs_by_order), 1),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addDeliveryOper(0, null)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.new), 1)
                  ]),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    disabled: _ctx.lstDeliveriesInfoByOrder.length == 0,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.printListItems && _ctx.printListItems(...args)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'print'] }),
                    _createTextVNode(" " + _toDisplayString(_ctx.language.print), 1)
                  ], 8, _hoisted_21),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.refresListItems && _ctx.refresListItems(...args))),
                    disabled: _ctx.isStillLoading
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'refresh'] }),
                    _createTextVNode(" " + _toDisplayString(_ctx.language.refresh), 1)
                  ], 8, _hoisted_22)
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_23, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, [
                    _createElementVNode("span", _hoisted_24, [
                      _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.language.delivs_by_order), 1)
                    ]),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.language.deliv_nbr), 1)
                  ]),
                  _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.language.date), 1),
                  _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.language.staff), 1),
                  _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.language.deliv_qty), 1),
                  _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.language.reciepient_name), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.lstDeliveriesInfoByOrder.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                      _createElementVNode("td", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.language.no_rec_fnd), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPageElts, (salesDet) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "acct-cal-verified",
                    key: salesDet.DeliveryOper.IdDelivery
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_34, [
                        _createElementVNode("a", {
                          href: "javascript:;",
                          onClick: ($event: any) => (_ctx.addDeliveryOper(1, salesDet)),
                          title: _ctx.language.details
                        }, _toDisplayString(salesDet.DeliveryOper.DeliveryNbr), 9, _hoisted_35),
                        _createTextVNode("  "),
                        _createVNode(_component_RouterLink, {
                          title: _ctx.language.details,
                          to: `/app/sales/deliveries/${salesDet.DeliveryOper.OrderKey}/${salesDet.DeliveryOper.DeliveryKey}/details`
                        }, {
                          default: _withCtx(() => [
                            _hoisted_36
                          ]),
                          _: 2
                        }, 1032, ["title", "to"])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.language.deliv_nbr) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, [
                            _createElementVNode("a", {
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.addDeliveryOper(1, salesDet)),
                              title: _ctx.language.preview
                            }, _toDisplayString(salesDet.DeliveryOper.OrderNbr), 9, _hoisted_40),
                            _createTextVNode("  "),
                            _createVNode(_component_RouterLink, {
                              title: _ctx.language.details,
                              to: `/app/sales/deliveries/${salesDet.DeliveryOper.OrderKey}/${salesDet.DeliveryOper.DeliveryKey}/details`
                            }, {
                              default: _withCtx(() => [
                                _hoisted_41
                              ]),
                              _: 2
                            }, 1032, ["title", "to"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.language.date) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatDateFr(salesDet.DeliveryOper.DeliveryDate, true)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.language.staff) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(salesDet.Staff.FirstName + ' ' + salesDet.Staff.LastName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.language.deliv_qty) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.DeliveredQty)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.language.reciepient_name) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(salesDet.DeliveryOper.ReceiverName), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_50, _toDisplayString(_ctx.appFxs.formatDateFr(salesDet.DeliveryOper.DeliveryDate, true)), 1),
                    _createElementVNode("td", _hoisted_51, _toDisplayString(salesDet.Staff.FirstName + ' ' + salesDet.Staff.LastName), 1),
                    _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.DeliveredQty)), 1),
                    _createElementVNode("td", _hoisted_53, _toDisplayString(salesDet.DeliveryOper.ReceiverName), 1)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["row margin-to-15", {'d-none': _ctx.lstDeliveriesInfoByOrder.length==0}])
            }, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createTextVNode(_toDisplayString(_ctx.language.total_entries) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.lstDeliveriesInfoByOrder.length), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("nav", _hoisted_57, [
                  _createVNode(_component_jw_pager, {
                    items: _ctx.filteredRecordItems,
                    initialPage: 1,
                    pageSize: _ctx.itemsPerPage,
                    maxPages: 10,
                    onChangePage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPageChange($event)))
                  }, null, 8, ["items", "pageSize"])
                ])
              ])
            ], 2)
          ])
        ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
      _createVNode(_component_printer_dialog, {
        visible: _ctx.isPrintvisible,
        onCloseForm: _ctx.onPrintClose,
        printBaseData: _ctx.printInitialValues,
        extraPrintData: _ctx.printExtraData
      }, null, 8, ["visible", "onCloseForm", "printBaseData", "extraPrintData"]),
      _createVNode(_component_DeliveryOperModal, {
        visible: _ctx.isDeliverModVis,
        initialValues: _ctx.deliverOpsRecord,
        recordStatus: _ctx.deliverOpsStatus,
        listOfUsers: _ctx.listOfUsers,
        onCloseForm: _ctx.onCloseDelivery
      }, null, 8, ["visible", "initialValues", "recordStatus", "listOfUsers", "onCloseForm"]),
      _createVNode(_component_DeliverOperDetailsModal, {
        visible: _ctx.isDelivDetailVisisble,
        listOfDetails: _ctx.serverLstOfRemainings,
        onCloseForm: _ctx.onClodeDelivDetails
      }, null, 8, ["visible", "listOfDetails", "onCloseForm"])
    ]))
  ], 64))
}